import appManager from '@app/appManager';
import { CallEvent } from '@modules/SoftPhoneModule/types';
import TasksModule from '@modules/TasksModule';
import { findStlTaskForCall } from './findStlTaskForCall';
import FeatureFlagModule, { FeatureFlagKeys } from '@modules/FeatureFlagModule';

const logger = appManager.logger('SpeedToLead');

/**
 * Handles phone.call.ended for STL tasks.
 *
 * When feature-speed-to-lead-outbounding-ai-task-outcome is OFF (default): sets `hasCallEnded`
 * to keep the task open so the CSR can log a disposition outcome manually.
 *
 * When feature-speed-to-lead-outbounding-ai-task-outcome is ON: deletes the task immediately
 * because the AI handles the outcome, transitioning the agent to IDLE and restoring the Claim CTA.
 */
function handleStlCallEnded(event: CallEvent) {
  if (!event.originating) return;

  const stlTask = findStlTaskForCall(event.remoteIdentity);
  if (!stlTask) return;

  if (
    FeatureFlagModule.isEnabled(
      FeatureFlagKeys.featureSpeedToLeadOutboundingAiTaskOutcome,
    )
  ) {
    logger.info('stl:call-ended:task-deleted', {
      taskId: stlTask.id,
      reason: 'ai-handles-outcome',
      flag: FeatureFlagKeys.featureSpeedToLeadOutboundingAiTaskOutcome,
    });
    TasksModule.deleteTask(stlTask.id);
  } else {
    logger.info('stl:call-ended:outcome-pending', {
      taskId: stlTask.id,
      reason: 'manual-disposition-required',
      flag: FeatureFlagKeys.featureSpeedToLeadOutboundingAiTaskOutcome,
    });
    TasksModule.setTaskAttribute(stlTask.id, 'hasCallEnded', true);
  }
}

export default handleStlCallEnded;
